import { render, staticRenderFns } from "./BoxMenu.vue?vue&type=template&id=2a532f2b&scoped=true&lang=pug&"
import script from "./BoxMenu.vue?vue&type=script&lang=js&"
export * from "./BoxMenu.vue?vue&type=script&lang=js&"
import style0 from "./BoxMenu.vue?vue&type=style&index=0&id=2a532f2b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a532f2b",
  null
  
)

export default component.exports